export function onTouchOrClick(element, callback) {
    let isTouching = false;
    function onTouchStart() {
        isTouching = true;
    }
    function onTouchCancel() {
        isTouching = false;
    }
    function onTouchEnd(e) {
        if (isTouching) {
            e.preventDefault();
            callback();
        }
    }
    element.addEventListener('click', callback);
    element.addEventListener('touchstart', onTouchStart, { passive: true });
    element.addEventListener('touchmove', onTouchCancel, { passive: true });
    element.addEventListener('touchcancel', onTouchCancel, { passive: true });
    element.addEventListener('touchend', onTouchEnd);
    return {
        destroy() {
            element.removeEventListener('click', callback);
            element.removeEventListener('touchstart', onTouchStart);
            element.removeEventListener('touchmove', onTouchCancel);
            element.removeEventListener('touchcancel', onTouchCancel);
            element.removeEventListener('touchend', onTouchEnd);
        },
    };
}
